import { createSlice } from '@reduxjs/toolkit';

export interface TEarningsVisibility {
  areEarningsVisible: boolean;
}

const initialState: TEarningsVisibility = {
  areEarningsVisible: true,
};

const earningsVisibilityDuck = createSlice({
  name: 'earningsVisibility',
  initialState,
  reducers: {
    toggleEarningsVisibility: (state) => {
      state.areEarningsVisible = !state.areEarningsVisible;
    },
  },
});

export const { toggleEarningsVisibility } = earningsVisibilityDuck.actions;

export default earningsVisibilityDuck.reducer;
